class RemoteUnlockProductPage {
    constructor() {
        this.elements = {
            ecuOpenedCheckbox: document.querySelector('input[type="checkbox"][id="agree"]'),
            addToCartButton: document.querySelector("div > buy-buttons > button"),
        }
        this.valid = {
            ecuOpened: false,
        };
    }

    init() {
        if (!this.elements.ecuOpenedCheckbox || !this.elements.addToCartButton) {
            console.error("Required elements not found on the page.");
            return;
        }

        this.elements.ecuOpenedCheckbox.addEventListener('change', () => {
            this.valid.ecuOpened = this.elements.ecuOpenedCheckbox.checked;
            this.setAddToCartButtonState();
        });


        // Initial state setup
        this.setAddToCartButtonState();
    }

    // should not be empty and be a hexadecimal string of 8 characters starting with 20
    validateInput(input) {
        input.value = input.value.toUpperCase().trim();
        input.classList.add('input-error');
        input.style.borderColor = 'red';

        if (input.value.length !== 8) return false;
        if (!/^[A-F0-9]{8}$/.test(input.value)) return false;
        if( !input.value.startsWith('20')) return false;

        input.classList.remove('input-error');
        input.style.borderColor = '';
        return true;
    }

    setAddToCartButtonState() {
        let btn = this.elements.addToCartButton;
        if (!this.formIsValid()) {
            btn.classList.add('disabled');
            btn.style.background = 'linear-gradient(90deg,#f0f0f0,#f0f0f0)';
            btn.setAttribute('aria-disabled', 'true');
            btn.setAttribute('disabled', 'disabled');
            return;
        }

        btn.style.display = 'block';
        btn.classList.remove('disabled');
        btn.removeAttribute('disabled');
        btn.removeAttribute('aria-disabled');
        btn.style.background = 'linear-gradient(90deg,#f85e00,#fa0)';
    }

    formIsValid() {
        for (const key in this.valid) {
            if (!this.valid[key]) {
                return false;
            }
        }
        return true;
    }
}

document.addEventListener('DOMContentLoaded', () =>{
    new RemoteUnlockProductPage().init();
})
